import { useEffect, useState } from 'react';

import Button from '@sympla/sympla-ui/lib/components/Button';
import Image from 'next/legacy/image';
import * as styles from './BannerCard.css';

interface ImageSet {
  app: string;
  web: string;
}

interface BannerCardProps {
  enabled: boolean;
  action: string;
  title?: string;
  description?: string;
  button_text?: string;
  display_on: string[];
  // style?: Style;
  images: ImageSet;
  order?: number;
  sectionPosition?: string;
  dataCreative?: string;
  is_clickable?: boolean;
  category?: string;
  isMobile?: boolean;
}

function BannerCard({
  enabled,
  action,
  title = '',
  description = '',
  button_text = '',
  display_on,
  // style = { button: '', banner: '' },
  images,
  order,
  sectionPosition,
  dataCreative,
  is_clickable = false,
  category = '',
  isMobile = false,
}: BannerCardProps) {
  const [imgUrl, setImgUrl] = useState('');

  useEffect(() => {
    setImgUrl(isMobile ? images.app : images.web);
  }, [isMobile, images]);

  const itsWeb = display_on.includes('web') && enabled;

  if (itsWeb && is_clickable && !imgUrl) {
    return null;
  }

  if (!itsWeb) {
    return null;
  }

  return (
    <div className={styles.BannerCardContainer}>
      <a
        href={action}
        rel="noopener noreferrer"
        className="sympla-banner-card"
        data-bannerid={`${order}`}
        data-name={title}
        data-position={`${sectionPosition}`}
        data-creative={dataCreative}
      >
        {is_clickable ? (
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <Image
              src={imgUrl}
              alt={category || title || ''}
              layout="fill"
              objectFit="cover"
            />
          </div>
        ) : (
          <div
            className={`${styles.BannerImageContainer} animated fadeIn`}
            style={{ backgroundImage: `url(${images.web || images.app || ''})` }}
          >
            <div className={styles.BannerContent}>
              {title && (
                <h2 className={styles.BannerTitle}>{title}</h2>
              )}
              {description && (
                <h3 className={styles.BannerDescription}>{description}</h3>
              )}
              {button_text && (
                <div className={styles.BannerButton}>
                  <Button
                    color="default"
                    variant="contained"
                    size="md"
                    uppercase
                  >
                    {button_text}
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </a>
    </div>
  );
}

export default BannerCard;
